/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Art_Value_SupplierInputs */

const en_svc_integration_art_value_supplier = /** @type {(inputs: Svc_Integration_Art_Value_SupplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`North Studio`)
};

const lv_svc_integration_art_value_supplier = /** @type {(inputs: Svc_Integration_Art_Value_SupplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`North Studio`)
};

/**
* | output |
* | --- |
* | "North Studio" |
*
* @param {Svc_Integration_Art_Value_SupplierInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_art_value_supplier = /** @type {((inputs?: Svc_Integration_Art_Value_SupplierInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Art_Value_SupplierInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_art_value_supplier(inputs)
	return en_svc_integration_art_value_supplier(inputs)
});